import { render, staticRenderFns } from "./CreateProjectTransfer.vue?vue&type=template&id=3d77044f&scoped=true"
import script from "./CreateProjectTransfer.vue?vue&type=script&lang=js"
export * from "./CreateProjectTransfer.vue?vue&type=script&lang=js"
import style0 from "./CreateProjectTransfer.vue?vue&type=style&index=0&id=3d77044f&prod&scoped=true&lang=css"
import style1 from "./CreateProjectTransfer.vue?vue&type=style&index=1&id=3d77044f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d77044f",
  null
  
)

export default component.exports